import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";
import api from "../api/axios";

const SelectCategory = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchCategoriesAndPreferences();
    }, []);

    const fetchCategoriesAndPreferences = async () => {
        try {
            setLoading(true);

            const [categoryRes, preferenceRes] = await Promise.all([
                api.get("/CategoryRoutes/customer/categories"),
                api.get("/customerProfileRoutes/customer/category-preferences/me")
            ]);

            if (categoryRes.data?.success) {
                setCategories(categoryRes.data.data || []);
            }

            if (preferenceRes.data?.success) {
                setSelectedCategoryIds(
                    preferenceRes.data.selected_category_ids || []
                );
            }

        } catch (error) {
            console.warn("Failed to fetch preferences:", error?.message || error);
        } finally {
            setLoading(false);
        }
    };

    const toggleCategory = (categoryId) => {
        setSelectedCategoryIds((prev) =>
            prev.includes(categoryId)
                ? prev.filter((id) => id !== categoryId)
                : [...prev, categoryId]
        );
    };

   const updatePreferences = async () => {
    if (selectedCategoryIds.length === 0) {
        toast.warning("Please select at least one category");
        return;
    }

    try {
        setSaving(true);

        const res = await api.put(
            "/customerProfileRoutes/customer/category-preferences/update",
            {
                category_ids: selectedCategoryIds
            }
        );

        if (res.data?.success) {
            window.dispatchEvent(new Event("categoryPreferenceUpdated"));

            toast.success(
                res.data?.message || "Preferences updated successfully"
            );
        }

    } catch (error) {
        console.warn("Preference update failed:", error?.message || error);

        toast.error(
            error?.response?.data?.message ||
            "Failed to update preferences"
        );

    } finally {
        setSaving(false);
    }
};

    return (
        <>
            <Col md={12} lg={12} xs={12} className="prof_title mb-4">
                <h4>Select Preference Category</h4>
            </Col>

            <Col md={12} lg={12} xs={12} className="p-0">
                <div className="category-box">
                    {loading ? (
                        <p>Loading categories...</p>
                    ) : (
                        <ul className="category-list">
                            {categories.map((cat) => {
                                const active = selectedCategoryIds.includes(cat.category_id);

                                return (
                                    <li
                                        key={cat.category_id}
                                        className={`category-item ${active ? "active" : ""}`}
                                    >
                                        <div
                                            className="category-content"
                                            onClick={() => toggleCategory(cat.category_id)}
                                        >
                                            <Checkbox
                                                inputId={`cat-${cat.category_id}`}
                                                checked={active}
                                                onChange={() => toggleCategory(cat.category_id)}
                                                className="selectCheckbox"
                                            />

                                            <img
                                                src={cat.image_url}
                                                alt={cat.category_name}
                                                className="category-img"
                                            />

                                            <label htmlFor={`cat-${cat.category_id}`}>
                                                {cat.category_name}
                                            </label>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>

                <div className="text-end mt-4">
                    <Button
                        label="Update Preferences"
                        loading={saving}
                        disabled={selectedCategoryIds.length === 0 || saving}
                        onClick={updatePreferences}
                        className="custbuttonpink billInfo"
                    />
                </div>
            </Col>
        </>
    );
};

export default SelectCategory;